import { ReactElement, ReactNode } from 'react';
import styles from './ui-nav.module.scss';
import { UIText } from '../ui-text';
import { NavLink } from 'react-router';
import { UINavPart } from './models';

type UINavProps = {
    parts: UINavPart[];
    /**
     * Pinned to the right of the breadcrumbs. A slot rather than a fixed
     * component: what belongs there is the app's business, not this bar's.
     */
    rightContent?: ReactNode;
};
export function UINav(props: UINavProps): ReactElement {
    const { parts, rightContent } = props;

    return (
        <nav className={styles.container}>
            <div className={styles.textContainer}>
                {parts.map((part, index) => {
                    const isLast = index === parts.length - 1;
                    return (
                        <span key={index}>
                            {part.link ? (
                                <>
                                    <NavLink to={part.link} state={part.state}>
                                        <UIText
                                            variant="h2"
                                            type="link"
                                            underline
                                        >
                                            {part.text}
                                        </UIText>
                                    </NavLink>
                                </>
                            ) : (
                                <UIText variant="h2" type={'default2'}>
                                    {part.text}
                                </UIText>
                            )}
                            {!isLast && (
                                <span
                                    style={{ paddingLeft: 4, paddingRight: 4 }}
                                >
                                    <UIText variant="h2" type={'default2'}>
                                        {' / '}
                                    </UIText>
                                </span>
                            )}
                        </span>
                    );
                })}
            </div>
            {rightContent}
        </nav>
    );
}
